import React from 'react';
import { Container, Row, Col } from 'src/interface/basics/grids';
import { Header, HeaderInner, HeaderBody, HeaderPretitle, HeaderTitle, HeaderSubtitle, HeaderText, HeaderBtns } from 'src/interface/basics/headers';
import { BtnLink, BtnNextLink, NextLink } from 'src/interface/basics/links';
import ShapesAnimation from 'src/interface/animations/shapes-animation';
import { GDesk } from 'src/assets';

const JobHeader = () => {

  return (
    <Header className='py-5 gradient-primary-accent'>
      <HeaderInner className='mvh-40'>
        <Container className='z-20' fluid='md'>
          <Row>
            <Col md={7}>
              <HeaderBody className='animate fade-in-up delay-200'>
                <HeaderPretitle>Jobs</HeaderPretitle>
                <HeaderTitle>Join our team</HeaderTitle>
                <HeaderText>
                  We're a team of designers, builders, and futurists that embrace change and are looking to make a dent in the world.
                  If that sounds like you, we'd love to hear from you.
                </HeaderText>
                <HeaderBtns className='animate fade-in-up delay-400'>
                  <BtnNextLink to='/contact' className='btn btn-opaque-white btn-lg'>Contact Us</BtnNextLink>
                </HeaderBtns>
              </HeaderBody>
            </Col>
          </Row>
        </Container>
      </HeaderInner>
      <ShapesAnimation />
    </Header>
  )
}

export default JobHeader;
